export default __webpack_public_path__ + "static/media/Quote1.41ae58b1.svg";